'use client'

import { Button } from 'fukku/Button'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useCallback, useEffect, useRef, useState } from 'react'
import { cx } from 'utils/cx'

import styles from './Scroll.module.scss'

const MIN_SCROLL = 100

export function Scroll(): React.ReactNode {
	const [visible, setVisible] = useState(false)
	const isVisible = useRef(false)
	const position = useRef(0)
	const { t } = useLabels()

	const onScroll = useCallback(() => {
		const scroll = window.scrollY
		let show = false

		if (scroll < position.current && scroll > MIN_SCROLL) {
			show = true
		}

		position.current = scroll

		if (show !== isVisible.current) {
			isVisible.current = show
			setVisible(show)
		}
	}, [])

	useEffect(() => {
		window.addEventListener('scroll', onScroll)

		return () => window.removeEventListener('scroll', onScroll)
	}, [])

	return (
		<div className={cx(styles.container, visible && styles.visible)}>
			<Button
				icon='up-large'
				iconPressed='up-large'
				label={t('plp.catalog.scroll-to-top')}
				onClick={() => {
					window.scrollTo({ top: 0, behavior: 'smooth' })
				}}
			/>
		</div>
	)
}
